import { render } from "./App.vue?vue&type=template&id=729e7475"
const script = {}

import "./App.vue?vue&type=style&index=0&id=729e7475&lang=scss"
script.render = render

export default script